<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

// import Stat from "@/components/widgets/stat";

/**
 * Dashboard Component
 */
export default {
   page: {
      title: "Dashboard",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      PageHeader,
      // Stat,
   },
   data() { 
      return {
         title: "Dashboard",
         items: [
            {
               text: "Dashboard",
               active: true,
            },        
         ],
      
         isLoading: false,

         pieChart: {
            series: [],
            chartOptions: {
               labels: ["Pending", "Cancelled", "Completed", "No Show"],
               colors: ["#50a5f1", "#f46a6a", "#34c38f", "#e91e63"],
               legend: {
                  show: true,
                  position: 'bottom',
                  horizontalAlign: 'center',
                  verticalAlign: 'middle',
                  floating: false,
                  fontSize: '14px',
                  offsetX: 0
               },
               responsive: [{
                  breakpoint: 600,
                  options: {
                     chart: {
                        height: 240
                     },
                     legend: {
                        show: false
                     },
                  }
               }]
            }
         }, // pieChart ends

         splineAreaChart: {
            series: [{
               name: 'Orders',
               data: []
            }],
            chartOptions: {
               chart: {
                  toolbar: {
                     show: false
                  }
               },
               dataLabels: {
                  enabled: false
               },
               stroke: {
                  curve: 'smooth',
                  width: 3,
               },
               colors: ['#34c38f'],
               xaxis: {
                  type: 'month',
                  categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
               },
               grid: {
                  borderColor: '#f1f1f1',
               },
               tooltip: {
                  x: {
                     format: 'dd/MM/yy HH:mm'
                  },
               }
            }
         }, //splineAreaChart ends

         splineAreaChart2: {
            series: [{
               name: 'Consultations',
               data: []
            }],
            chartOptions: {
               chart: {
                  toolbar: {
                     show: false
                  }
               },
               dataLabels: {
                  enabled: false
               },
               stroke: {
                  curve: 'smooth',
                  width: 3,
               },
               colors: ['#34c38f'],
               xaxis: {
                  type: 'month',
                  categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
               },
               grid: {
                  borderColor: '#f1f1f1',
               },
               tooltip: {
                  x: {
                     format: 'dd/MM/yy HH:mm'
                  },
               }
            }
         }, 
         cancelled: 0,
         completed: 0,
         noshow: 0,
         pending: 0,

         active_doctors: 0,
         total_doctors:0,
         today_doctors:0,
         week_doctors:0,
         month_doctors:0,

         registered_patients: 0,
         today_patients:0,
         week_patients:0,
         month_patients:0,

         total_clinics:0,
         today_clinics:0,
         week_clinics:0,
         month_clinics:0,

         total_labs:0,
         today_labs:0,
         week_labs:0,
         month_labs:0,

         offline_earnings: 0,
         online_earnings: 0,
         total_earnings: 0,
         pharmacy_earnings:0,

         doctor_requests:0,
         schedule_requests:0,
         pharmacy_requests:0,


         todays_consultations: 0,
         todays_offline_consultations: 0,
         months_offline_consultations:0,
         weeks_offline_consultations:0,
         total_offline_consultations:0,
         todays_online_consultations: 0,
         weeks_online_consultations:0,
         months_online_consultation:0,
         weeks_online_consultation:0,
         total_online_consultations:0,
         consultations: [],
         doctors: [],
         patients: [],

         expense: {
					svgIcon : "expense",
					title :  "Expense",
					total_expense : "",
				},
				
				income: {
					svgIcon : "orders",
					title :  "Income",
					total_income : "",
				},

				months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

      };
   },
   mounted() {},

   created() {
      this.fetchDashboard();
   },

   methods: {
      fetchDashboard() {
         let url = "api/admin/dashboard";
            
         this.getToken();
         this.loading = true;
         this.$axios
         .get(url, { headers: { Authorization: "Bearer " + this.token } })
         .then((res) => {
            var data = res.data.data;
            console.log(data);  

            this.active_doctors = data.active_doctors;
            this.total_doctors = data.total_doctors;
            this.month_doctors = data.month_doctors;
            this.week_doctors = data.week_doctors;
            this.today_doctors = data.today_doctors;

            this.total_clinics = data.total_clinics;
            this.month_clinics = data.month_clinics;
            this.week_clinics = data.week_clinics;
            this.today_clinics = data.today_clinics;

            this.total_labs = data.total_labs;
            this.month_labs = data.month_labs;
            this.week_labs = data.week_labs;
            this.today_labs = data.today_labs;

            // this.offline_earnings = data.offline_earnings;
            // this.online_earnings = data.online_earnings;
            // this.total_earnings = data.total_earnings;
            // this.pharmacy_earnings = data.pharmacy_earnings;

            this.offline_earnings = parseFloat(data.offline_earnings);
            this.online_earnings = parseFloat(data.online_earnings);
            this.total_earnings = parseFloat(data.total_earnings);
            this.pharmacy_earnings = parseFloat(data.pharmacy_earnings);

            this.registered_patients = data.registered_patients;
            this.month_patients = data.month_patients;
            this.week_patients = data.week_patients;
            this.today_patients = data.today_patients;

            this.doctor_requests = data.doctor_requests;
            this.schedule_requests = data.schedule_requests;
            this.pharmacy_requests = data.pharmacy_requests;

            this.todays_consultations = data.todays_consultations;
            this.todays_offline_consultations = data.todays_offline_consultations;
            this.months_offline_consultations = data.months_offline_consultations;
            this.weeks_offline_consultations = data.weeks_offline_consultations;
            this.total_offline_consultations = data.total_offline_consultations;            
            this.todays_online_consultations = data.todays_online_consultations;
            this.months_online_consultation = data.months_online_consultation;
            this.weeks_online_consultations = data.weeks_online_consultations;
            this.total_online_consultations = data.total_online_consultations;

            this.consultations = data.consultations;
            this.doctors = data.doctors;
            this.patients = data.patients;   

            this.splineAreaChart.series[0].data = data.completed_patient_orders;
            this.splineAreaChart2.series[0].data = data.completed_consultations;

            this.pieChart.series[2] = data.completed;
            this.pieChart.series[3] = data.noshow;
            this.pieChart.series[1] = data.cancelled;
            this.pieChart.series[0] = data.pending;

               
         })
         .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
         })
         .finally(() => (this.loading = false));
      },



      getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      }, 
   }
};
</script>

<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="col-lg-12">
         <div class="row">
            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Online Consultations</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-laptop-medical font-size-20"></i>                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ todays_online_consultations.toString() }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{months_online_consultation.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{weeks_online_consultations.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{total_online_consultations.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>
                             
                           </div>
                        </div>
            </div>

            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Offline Consultations</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-hospital-user font-size-20"></i>                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ todays_offline_consultations.toString() }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{months_offline_consultations.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{weeks_offline_consultations.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{total_offline_consultations.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>
                             
                           </div>
                        </div>
            </div>
            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Doctors</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-user-md font-size-20"></i>                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ today_doctors.toString() }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{month_doctors.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{week_doctors.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{total_doctors.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>
                           </div>
                        </div>
            </div>
            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Patients</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-procedures font-size-20"></i>                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ today_patients.toString() }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{month_patients.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{week_patients.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{registered_patients.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>
                             
                           </div>
                        </div>
            </div>
            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Clinics</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-regular fa-hospital font-size-20"></i>                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ today_clinics.toString() }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{month_clinics.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{week_clinics.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{total_clinics.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>
                             
                           </div>
                        </div>
            </div>
            <div class="col-md-3">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              <div class="media mb-3">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Labs</p>
                                 </div>

                                 <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-solid fa-flask font-size-20"></i>                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Today</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{ today_labs.toString() }}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Month</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{month_labs.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">This Week</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{week_labs.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>

                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Total</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <h4 class="mb-0 font-size-16">{{total_labs.toString()}}</h4>
                                 </span>
                                 </div>
                              </div>
                             
                           </div>
                        </div>
            </div>

         
            <div class="col-md-6">
				<div class="row-md-2">
					<div class="card-dashboard">
						<div class="media mb-2 media-dashboard">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Pending Doctor Requests</p>							
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-size-16"> {{ doctor_requests.toString() }}</h6>
								</span>
							</div>
						</div>
                  
							<!-- <div class="media">
								<div class="media-body">
									<p class="tild-head text-primary" style="font-weight: 800;">Orders</p>
								</div>
							</div> -->
					</div>
				</div>
				<div class="row-md-2">
					<div class="card-dashboard">
						<div class="media mb-2 media-dashboard">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Pending Schedule requests</p>							
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-size-16"> {{ schedule_requests.toString() }}</h6>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="row-md-2">
					<div class="card-dashboard">
						<div class="media mb-2 media-dashboard">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Pending Pharmacy requests</p>						
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-weight-400"> {{ pharmacy_requests.toString()  }}</h6>
								</span>
							</div>
						</div>
					</div>
				</div>
            

			</div>
         </div>
      </div>

      <!-- <div class="card-body">
    <h4 class="card-title mb-7">Earnings</h4>
    <div class="text-center">
        <div class="mb-4">
            <i class="fas fa-hand-holding-usd display-4"></i>
        </div>
        <h3>{{total_earnings.toString()}}</h3>
        <p>Today's Total</p>
    </div>
    <div class="table-responsive mt-4">
        <table class="table table-centered">
            <tbody>
                <tr>
                    <td colspan="3">
                        <div class="d-flex align-items-center justify-content-between">
                            <p class="mb-0">Today's Online Earnings</p>
                            <h5 class="mb-0">{{online_earnings.toString()}}</h5>
                            <div class="progress" style="height: 5px; width: 500px;">
                                <div class="progress-bar bg-primary" role="progressbar" aria-valuenow="94" aria-valuemin="0" style="width: 44%;"></div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <div class="d-flex align-items-center justify-content-between">
                            <p class="mb-0">Today's Offline Earnings</p>
                            <h5 class="mb-0">{{offline_earnings.toString()}}</h5>
                            <div class="progress" style="height: 5px;width: 500px;">
                                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="82" aria-valuemin="0" style="width: 82%;"></div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <div class="d-flex align-items-center justify-content-between">
                            <p class="mb-0">Today's Pharmacy Earnings</p>
                            <h5 class="mb-0">{{pharmacy_earnings.toString()}}</h5>
                            <div class="progress" style="height: 5px; width: 500px;">
                                <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="70" aria-valuemin="0" style="width: 70%;"></div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div> -->

<!-- .......................................................................... -->
<!-- <div class="col-xxl-12 box-col-12">
				<div class="card">
					<div class="card-header card-no-border">
							<div class="header-top">
								<h5 class="m-0">Earnings Overview</h5>
								<div class="card-header-right-icon">
									<div class="dropdown">
										<select class="form-select">
                                            <option value="">Total</option>
                                            <option :value="1">Today</option>
                                            <option :value="2">This Week</option>
											<option :value="3">This Month</option>
                                        </select>
										
									</div>
								</div>
							</div>
						</div>
					
					<div class="card-body pt-0">
						<div class="row m-0 overall-card overview-card">
							<div class="col-xl-9 col-md-8 col-sm-7 p-0 box-col-7">
								<div class="chart-right">
									<div class="row">
										<div class="col-xl-12">
											<div class="card-body p-0">
												<ul class="balance-data">
													<li>
														<span class="circle bg-secondary"></span><span class="f-light ms-1">Total Income</span>
													</li>
													<li>
														<span class="circle bg-primary"> </span><span class="f-light ms-1">Total Expense</span>
													</li>
													
												</ul>
												<div class="current-sale-container order-container">
													<div class="overview-wrapper">
														<apexchart height="265" type="line" :options="ecomDashboard.options2" :series="ecomDashboard.series2"></apexchart>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-3 col-md-4 col-sm-5 p-0 box-col-5">
								<div class="row g-sm-3 g-2">
										<div class="col-md-12">
											<div class="light-card balance-card widget-hover">
												<div class="svg-box">
													<svg class="svg-fill">
														<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${income.svgIcon}`"></use>
													</svg>
												</div>
												<div class="ms-3">
													<span class="f-light">Income</span>
													<h6 class="mt-1 mb-0"><i class="fa fa-euro"></i>1000</h6>
													
												</div>
												
											</div>
										</div>

										<div class="col-md-12">
											<div class="light-card balance-card widget-hover">
												<div class="svg-box">
													<svg class="svg-fill">
														<use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${expense.svgIcon}`"></use>
													</svg>
												</div>
												<div class="ms-3">
													<span class="f-light">Expense</span>
													<h6 class="mt-1 mb-0"><i class="fa fa-euro"></i>900</h6>
												</div>
												
											</div>
										</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->


       <div class="row mb-5">
         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20  p-3 mb-3">Consultations</h4>
                  <apexchart v-if="pieChart.series.length"
                    class="apex-charts"
                    height="320"
                    type="pie"
                    dir="ltr"
                    :series="pieChart.series"
                    :options="pieChart.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>


         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20  p-3 mb-3">Pharmacy Orders</h4>
                  <apexchart  v-if="splineAreaChart.series[0].data.length"
                    class="apex-charts"
                    height="350"
                    type="area"
                    dir="ltr"
                    :series="splineAreaChart.series"
                    :options="splineAreaChart.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>
      </div> 
<div class="row">
      <div class="col-md-8">
            <div class="card h-90">
               <div class="card-body">
                  <h4 class="font-size-20  p-3 mb-3">Monthly Consultations</h4>
                  <apexchart  v-if="splineAreaChart2.series[0].data.length"
                    class="apex-charts"
                    height="250"
                    type="area"
                    dir="ltr"
                    :series="splineAreaChart2.series"
                    :options="splineAreaChart2.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>

         <div class="col-md-4">
				<div class="row-md-2">
					<div class="card-dashboard">
						<div class="media mb-2 media-dashboard">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Today's Online Earnings</p>							
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-size-16"> ₹{{ online_earnings.toFixed(2)}}</h6>
								</span>
							</div>
						</div>
						
					</div>
				</div>
				<div class="row-md-2">
					<div class="card-dashboard">
						<div class="media mb-2 media-dashboard">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Today's Offline Earnings</p>							
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-size-16"> ₹{{ offline_earnings.toFixed(2) }}</h6>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="row-md-2">
					<div class="card-dashboard">
						<div class="media mb-2 media-dashboard">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Today's Pharmacy Earnings</p>						
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-size-16"> ₹{{ pharmacy_earnings.toFixed(2)  }}</h6>
								</span>
							</div>
						</div>
					</div>
				</div>
            <div class="row-md-2">
					<div class="card-dashboard">
						<div class="media mb-2 media-dashboard">
							<div class="media-body">
								<p class="tild-head text-primary" style="font-weight: 800;">Today's Total Earnings</p>						
							</div>

							<div class="align-self-center ">
								<span class="float-end me-3">
									<h6 class="font-size-16"> ₹{{ total_earnings.toFixed(2) }}</h6>
								</span>
							</div>
						</div>
					</div>
				</div>

			</div>
      </div>
      <!-- end row -->


      <div class="row">

         <div class="col-md-4">
            <div class="card">

               <div class="card-header bg-light p-3 d-flex justify-content-between">
                  <div class="header-title">
                     <h6 class="card-title">Doctors</h6>
                  </div>
                  <div class="card-header-toolbar d-flex align-items-center">
                     <router-link :to="{ name: 'doctors' }" class="btn btn-sm btn-outline-primary view-more">View all</router-link>
                  </div>
               </div>

               <div class="card-body">                  
                  <ul class="list-inline p-0 m-0">
                     <router-link :to="{ name: 'doctors.details', params: {id: doctor.id} }" v-for="(doctor) in doctors" :key="doctor.id">
                        <li class="media align-items-center mb-3">
                           <img v-if="doctor.image" :src="$image_url + doctor.image" alt="image" class="avatar-sm rounded-circle" />
                           <img v-else src="@/assets/images/no-user.jpg" class="avatar-sm rounded-circle" alt="image" />
                           <div class="media-body ms-3">
                              <h6 class="mb-0 font-size-14"><span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span> {{doctor.name}}</h6>
                              <p class="mb-0 text-primary">{{doctor.country_code}} {{doctor.mobile}}</p>
                              <p class="mb-0">{{doctor.created_at | formatDateTime}}</p>
                           </div>
                        </li>
                     </router-link>
                  </ul>
               </div>
            </div>
            <!-- end card -->
         </div>

         <div class="col-md-4">
            <div class="card">

               <div class="card-header bg-light p-3 d-flex justify-content-between">
                  <div class="header-title">
                     <h6 class="card-title">Patients</h6>
                  </div>
                  <div class="card-header-toolbar d-flex align-items-center">
                     <router-link :to="{ name: 'patients' }" class="btn btn-sm btn-outline-primary view-more">View all</router-link>
                  </div>
               </div>

               <div class="card-body">                  
                  <ul class="list-inline p-0 m-0">
                     <router-link :to="{ name: 'patients.details', params: {id: patient.id} }" v-for="(patient) in patients" :key="patient.id">
                        <li class="media align-items-center mb-3">
                           <img v-if="patient.image" :src="$image_url + patient.image" alt="image"  class="avatar-sm rounded-circle"/>
                           <img v-else src="@/assets/images/no-user.jpg" class="avatar-sm rounded-circle" alt="image" />
                           <div class="media-body ms-3">
                              <h6 class="mb-0 font-size-14">{{patient.name}}</h6>
                              <p class="mb-0 text-primary">{{patient.country_code}} {{patient.mobile}}</p>
                              <p class="mb-0">{{patient.created_at | formatDateTime}}</p>
                           </div>
                        </li>                   
                     </router-link>
                  </ul>
               </div>
            </div>
            <!-- end card -->
         </div>

         <div class="col-md-4">
            <div class="card">

               <div class="card-header bg-light p-3 d-flex justify-content-between">
                  <div class="header-title">
                     <h6 class="card-title">Consultations</h6>
                  </div>
                  <div class="card-header-toolbar d-flex align-items-center">
                     <router-link :to="{ name: 'consultations' }" class="btn btn-sm btn-outline-primary view-more">View all</router-link>
                  </div>
               </div>

               <div class="card-body">                  
                  <ul class="list-inline p-0 m-0">
                     <router-link :to="{ name: 'consultations.details', params: {id: consultation.booking_id} }" v-for="(consultation) in consultations" :key="consultation.booking_id">
                        <li class="media align-items-center mb-3">
                           <img v-if="consultation.image" :src="$image_url + consultation.image" alt="image"  class="avatar-sm rounded-circle"/>
                           <img v-else src="@/assets/images/no-user.jpg" class="avatar-sm rounded-circle" alt="image" />
                           <div class="media-body ms-3">
                              <h6 class="mb-0 font-size-14"><span v-if="consultation.name">{{consultation.name}}</span><span v-else>Guest</span></h6>
                              <p class="mb-0 text-primary">{{consultation.country_code}} {{consultation.mobile}}</p>
                              <p class="mb-0">{{consultation.booking_date | formatDate}}, {{consultation.consultation_start | formatTime}}</p>
                           </div>
                        </li>
                     </router-link>
                  </ul>
               </div>
            </div>
            <!-- end card -->
         </div>
      </div>
      <!-- end row -->

    
   </Layout>
</template>
